import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "product-media",
  class ProductMedia extends WYATTElement {
    constructor() {
      super();
      if (this.config.modalSelector) {
        // Scope the lookup: a variant update swaps in a new live region with its own modal.
        this.modal = (this.closest("live-region") || document).querySelector(
          this.config.modalSelector,
        );
        if (this.modal) {
          this.modalToggle = this.querySelectorAll("[data-open-modal]");
          this.modalToggle.forEach((button) => {
            button.addEventListener("click", this.openModal.bind(this));
          });
        }
      }
    }

    openModal(event) {
      event.preventDefault();
      const index = parseInt(event.currentTarget.dataset.mediaIndex, 10) || 0;
      this.modal.open(event);
      this.goToModalSlide(index);
    }

    goToModalSlide(index) {
      const slider = this.modal.dialog?.querySelector(
        "[data-zoom-image-slider]",
      );
      if (!slider || typeof slider.goTo !== "function") return;
      slider.goTo(index, "instant");
      slider.navigatedBy?.goTo(index);
    }
  },
);

// Missing/draft Cylindo products are handled by the viewer itself
// (product-validation-strategy + slot="product-fallback"). This only swaps the
// placeholder so a 404ing frame-1 never flashes while that validation runs.
// Each viewer owns its placeholder: in the modal it lives outside <product-media>.
registerComponent(
  "product-cylindo",
  class ProductCylindo extends WYATTElement {
    constructor() {
      super();
      const image = this.querySelector(
        "cylindo-viewer img[data-cylindo-fallback]",
      );
      if (!image) return;

      const swapToFallback = () => {
        image.src = image.dataset.cylindoFallback;
      };

      if (image.complete && image.naturalWidth === 0) {
        swapToFallback();
      } else {
        image.addEventListener("error", swapToFallback, { once: true });
      }
    }
  },
);
